



































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FilterIcon,
  SearchIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'business-year-filter',
  components: {
    CalendarIcon,
    Multiselect,
    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CheckSquareIcon,
    CheckIcon,
  },
})
export default class DateFilterComponent extends mixins(BaseMixin, FilterMixin) {
  @Prop({ type: Number })
  selected!: number;

  @Prop({ type: String, default: () => '' })
  title!: string;

  @Prop({ type: String, default: () => '' })
  clazz!: string;

  @Prop({ type: Boolean, default: () => false })
  hideIcon!: boolean;

  @Prop({ type: Boolean, default: () => false })
  hideReset!: boolean;

  changed(val: number) {
    this.$emit('update', val);
  }

  get isDefault() {
    return this.selected === new Date().getFullYear();
  }

  reset() {
    this.$emit('update', new Date().getFullYear());
  }
  get yearOptions() {
    const startYear = new Date(this.agency.createdAt).getFullYear();
    const currentYear = new Date().getFullYear();
    // create array with years from startYear to currentYear
    return Array.from(
      { length: currentYear + 2 - startYear + 2 },
      (_, i) => startYear + i,
    ).reverse();
  }

  labelYear(year: number) {
    return `Geschäftsjahr ${year}`;
  }
}
